export default __webpack_public_path__ + "static/media/Iconmagnum.54f24acf.png";